import { createApiCall } from 'lib/base';

const DELETE_SUBSCRIPTION_OPTION = 'DELETE_SUBSCRIPTION_OPTION';

const deleteSubscriptionOptionApi = createApiCall<{ id: string; optionId: string }>(
  DELETE_SUBSCRIPTION_OPTION,
  ({ id, optionId }) => ({
    endpoint: `api/admin/subscriptions/${id}/options/${optionId}`,
    method: 'DELETE',
  })
);

export default deleteSubscriptionOptionApi;
